import TypePagesItems from '../Models/TypePagesItems'

const pagesItems: TypePagesItems[] = [
  {
    title: 'Биохимические анализаторы',
    link: '/analizatory/Biokhimiya',
    id: '11',
    nodeType: 'Category',
    type: 'categoryList',
    tid: '4',
  },
  {
    title: 'Иммуноферментные анализаторы',
    link: '/analizatory/immuno',
    id: '14',
    nodeType: 'Category',
    type: 'categoryList',
    tid: '4',
  },
  {
    title: 'Биохимические реактивы',
    link: '/Reaktivy',
    id: '1',
    nodeType: 'Maincategory',
    type: 'categoryList',
    tid: '3',
  },
]

export default pagesItems
